import { gql } from "@apollo/client";


export const GET_GRILLA_CONEXIONES = gql`
query grillaConexiones($idDelegacion:Int!, $year: Int!, $month: Int!){
    grillaConexiones(idDelegacion: $idDelegacion, anio: $year, mes: $month){
        idPaciente
        idContrato
        contratoFechaDesde
        contratoFechaHasta
        codigoSAP
        documento
        nombrePaciente
        tipoPlan
        plan
        cantConexionesPendiente
        cantConexionAutorizada
        cantConexionSuspendida
    }
}
`;

const adaptConexionRow = (conexion) => {
  return {
    hc: conexion?.idPaciente,
    contrato: conexion?.idContrato,
    contratoFechaDesde: conexion?.contratoFechaDesde,
    contratoFechaHasta: conexion?.contratoFechaHasta,
    codSAP: conexion?.codigoSAP,
    documento: conexion?.documento?.toString(),
    nombrePaciente: conexion?.nombrePaciente,
    planTipo: conexion?.tipoPlan,
    plan: conexion?.plan,
    cantConexionesPendiente: conexion?.cantConexionesPendiente,
    cantConexionAutorizada: conexion?.cantConexionAutorizada,
    cantConexionSuspendida: conexion?.cantConexionSuspendida
  };
};

export const adaptConexionesArray = (conexiones) => {
  return (
    structuredClone(
      conexiones?.grillaConexiones
    )?.map((conexion) => adaptConexionRow(conexion)) || []);

};